
const RTE_SHORTCUT ={
    ADD_COLUMN_LEFT : { win: 'ctrl+alt+left', mac: 'ctrl+alt+left' },
    ADD_COLUMN_RIGHT : { win: 'ctrl+alt+right', mac: 'ctrl+alt+right' },
    ADD_ROW_ABOVE : { win: 'ctrl+alt+up', mac: 'ctrl+alt+up' },
    ADD_ROW_BELOW : { win: 'ctrl+alt+down', mac: 'ctrl+alt+down' },
}

export default RTE_SHORTCUT;